import React, { useEffect, useState } from 'react'; 
import FalconComponentCard from 'components/common/FalconComponentCard'; 
import firebase from './../../../firebase';
import { useParams } from 'react-router-dom';
import { Button,  Col, Form, Row } from 'react-bootstrap';  
import DatePicker , {registerLocale, setDefaultLocale} from 'react-datepicker';
 
import {   useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify'; 
import fr from 'date-fns/locale/fr'; 


const EditComptabilite = () => { 
    const { id } = useParams();
    registerLocale('fr', fr);
    setDefaultLocale('fr'); 
    const [validated, setValidated] = React.useState(false); 
    const [formd, setFrom] = React.useState({});
    const [l, setL] = React.useState(false); 
    
    const [lfile, setLFile] = React.useState(false);
    const [newfile, setNewFile] =  React.useState([]);
 
    const [files, setFiles] = React.useState([]);
 
  const characters =
  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  function generateString(length) {
  let result = '';
  const charactersLength = characters.length;
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < length; i++) {
  result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
  } 
  
  const handleSubmitFile = (event) => { 
    event.preventDefault();
    event.stopPropagation(); 
    
    
    const sendFile = async (file, cb) => {
        const storage = firebase.storage();
        const metadata = {
          contentType: file.type,
        };
     
        const ss = `files/${generateString(10)}.${file?.type?.split("/")[1]}`;
        const reference = storage.ref(ss);
    
     
            const uploadTask = reference.put(file, metadata);
    
                uploadTask.on(
                  firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
                  (snapshot) => {
                    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                    var progress =
                      (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    console.log(`Upload is ${  progress  }% done`);
                    switch (snapshot.state) {
                      case firebase.storage.TaskState.PAUSED: // or 'paused'
                        console.log("Upload is paused");
                        break;
                      case firebase.storage.TaskState.RUNNING: // or 'running'
                        console.log("Upload is running");
                        break;
                      default :
                        break;
                    }
                  },
                  (err) => {
                    // A full list of error codes is available at
                    // https://firebase.google.com/docs/storage/web/handle-errors
                    switch (err.code) {
                      case "storage/unauthorized":
                        console.error("err", err)
                        // User doesn't have permission to access the object
                        alert(
                          "Une erreur est survenue lors de l'envoie de votre fichier, vous n'avez pas l'autorisation d'envoyez des documents."
                        );
                        break;
                      case "storage/canceled":
                        // User canceled the upload alert(
                        alert(
                          "Une erreur est survenue lors de l'envoie de votre fichier, vous avez annuler l'envoie."
                        );
                        break;
    
                      // ...
    
                      case "storage/unknown":
                        // Unknown error occurred, inspect error.serverResponse
                        alert(
                          "Une erreur est survenue lors de l'envoie de votre fichier, réessayer plus tard."
                        );
                        break;
                      default :
                        break;
                    }
                  },
                  () => {
                    console.log("Image uploaded to the bucket!");
    
    
    
                    uploadTask.snapshot.ref
                      .getDownloadURL()
                      .then(async (downloadURL) => {
                        cb(downloadURL)
                      });
                  }
                ); 
    
    
      };

    if (newfile.length > 0){
        var ng = files;
        var index = 0  ;
        setLFile(true);

        Array.from(newfile).forEach(async (n) => { 
            await sendFile(n, async (downloadURL) => { 
                ng.push(downloadURL)
                index += 1;
                if (index === newfile.length){ 
                   try {
                       firebase.firestore().collection('bookings').doc(id).update({files:ng}).then(() => {
                           console.log("Document successfully written!");
                           toast.success("Fichier(s) ajoutée avec succès");
                           setNewFile([]);
                           setFiles(ng);
                           var f = {...formd}
                           f.files = ng
                           setFrom(f)
                           console.log("ng", ng);
                           setLFile(false)
                       }).catch((error) => {
                           setL(false); 
                           console.error("error", error)
                           var errorMessage = error.message;
                           toast.error(errorMessage); 
                           setLFile(false)
                       })
                   } catch (error) { 
                        setLFile(false) 
                       var errorMessage = error.message;
                       toast.error(errorMessage);
                   } 
                }
               })
        })

    }
  }
 

  useEffect(() =>{
    if (id)  {  
        firebase.firestore().collection('bookings').doc(id).get().then(doc => {
          if (doc){ 
            let d = doc.data() 
            d.id = doc.id; 
            setFrom(d)   
            setFiles(d?.files || [])
          }
        }).catch(() => {
            toast.error('Une erreur s\'est produite. La base de données est actuellement inaccessible, réessayer dans quelques minutes');
        })
      }else{
        toast.error('Une erreur s\'est produite.');
      }
  }, []);



  const delFile = (index) => {
    if(confirm(`Êtes vous certain de vouloir supprimer le fichier?`)){
        let b  = [] 
        files.forEach((c , i)=> {
            if (i !== index){
                b.push(c)
            }
        })
        setLFile(true);  


        try {
            firebase.firestore().collection('bookings').doc(id).update({files:b}).then((snap)=> {
            
                setLFile(false); 
                var f = {...formd}
                f.files = b
                setFrom(f)
                setFiles(b);   

                toast.success("Suppression effectué");
            })
        } catch (err) {
            setLFile(false); 
            // eslint-disable-next-line no-console
            console.log(err);
            toast.error("Une erreur s'est produite");
        } 

    }
}
  return (<>
  
  

  <FalconComponentCard>
        <FalconComponentCard.Header title={`Edition suivis réservation - ${id}`} light={false} noPreview={true}  />
        <FalconComponentCard.Body >
        <Row className="g-2">
            <Col xs={4}>
                        <Form noValidate validated={validated} onSubmit={handleSubmitFile} >
                            <Form.Control type="file" name="file" multiple  
                                onChange={(value) => {
                                    console.log("file", value?.target?.files)
                                    setNewFile(value?.target?.files)
                                }}
                             />
                            <Button color="primary" disabled={lfile || newfile.length === 0 }  type="submit" className="px-5 my-3">
                                {lfile ?"Chargement..": "Ajouter les fichiers"}
                            </Button>
                            </Form>
                        </Col>
                            {!lfile && files?.map((f, i) => {
                                return (
                                    <Col xs={2}>
                                       <p style={{textAlign:'center'}}> <a href={f}   target='_blank'>Voir le fichier</a></p>
                                        <p style={{textAlign:'center'}}><a style={{color:'red'}} onClick={() => {delFile(i)}} >Supprimer</a></p>
                                    </Col>)
                            })}
                        </Row> 
        </FalconComponentCard.Body>
    </FalconComponentCard> </>
  );  
  };

export default EditComptabilite;
